var module = angular.module('octopusApp.environments');

module.service('endpoints', function () {

  this.communicationStyles = [
    { label: 'Listening Tentacle', value: 'TentaclePassive', port: 10933, discoverable: true, helpHtml: 'Connect to a machine via a Tentacle in Listening mode' },
    { label: 'Polling Tentacle', value: 'TentacleActive', port: 10933, helpHtml: 'Connect to a machine via a Tentacle in Polling mode' },
    { label: 'SSH Connection', value: 'Ssh', port: 22, discoverable: true, helpHtml: 'Connect to a machine via Secure Shell (SSH)' },
    { label: 'Offline Package Drop', value: 'OfflineDrop', helpHtml: 'Configure a location to drop Offline Deployment Packages' },
    { label: 'Cloud Region', value: 'None', helpHtml: 'A convenient way to model multiple geographic regions' }
  ];

  this.canDiscover = function(value) {
    if(value) {
      return _.findWhere(this.communicationStyles, {value: value}).discoverable;
    }
  };

  this.isListeningTentacle = function(value) {
    return value === this.communicationStyles[0].value;
  };

  this.isPollingTentacle = function(value) {
    return value === this.communicationStyles[1].value;
  };

  this.getDefaultPort = function (value) {
    if(value) {
      return _.findWhere(this.communicationStyles, {value: value}).port;
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/services/endpoints.js
// module id = 3007745483597627
// module chunks = 1